import type { TenantOnboardingDTO, TenantOnboardingStepPatch } from '@today/types'
import { apiClient } from './api.client'

const path = (slug: string) => `/t/${encodeURIComponent(slug)}/admin/onboarding`

/** The tenant onboarding wizard's progress (TO-190 tenant-onboarding-wizard). */
export const tenantOnboardingService = {
	get: async (slug: string) => (await apiClient.get<TenantOnboardingDTO>(path(slug))).data,
	setStep: async (slug: string, body: TenantOnboardingStepPatch) =>
		(await apiClient.patch<TenantOnboardingDTO>(path(slug), body)).data,
}
